export const EMAIL_REACTIVATION_CAMPAIGN = "inquira_free_forever_launch";
export const EMAIL_REACTIVATION_WINDOW_DAYS = 30;

export function isEmailReactivation(a: { utmSource?: string; utmMedium?: string; utmCampaign?: string }): boolean {
  return a.utmSource === "email" && a.utmMedium === "reactivation" && a.utmCampaign === EMAIL_REACTIVATION_CAMPAIGN;
}

/** Preview observations must never enter live revenue reporting. */
export function campaignEnvironment(hostname: string): "live" | "staging" {
  return ["inquira.online", "www.inquira.online", "inquira.lovable.app"].includes(hostname.toLowerCase()) ? "live" : "staging";
}

export function classifyCampaignAccount(createdAt: number, previousStudyAt: number | null, touchAt: number): "new" | "inactive" | "active" | "unknown" {
  if (createdAt >= touchAt) return "new";
  if (previousStudyAt === null) return "unknown";
  return previousStudyAt < touchAt - EMAIL_REACTIVATION_WINDOW_DAYS * 86400000 ? "inactive" : "active";
}